import { PaginatedResponse } from "@/redux/types";

export const isPaginatedResponse = <T>(
  response: T[] | PaginatedResponse<T>,
): response is PaginatedResponse<T> => {
  return "results" in response;
};
